import Skeleton from "react-loading-skeleton";
import { TableBody, TableCell, TableRow } from "@/components/catalyst/Table";
import { AppPartnersDialogLayout } from "./AppPartnersDialogLayout";

interface AppPartnersDialogSkeletonProps {
	isOpen: boolean;
	onClose: () => void;
}

export function AppPartnersDialogSkeleton({
	isOpen,
	onClose,
}: AppPartnersDialogSkeletonProps) {
	return (
		<AppPartnersDialogLayout isOpen={isOpen} onClose={onClose}>
			<TableBody>
				{Array.from({ length: 3 }).map((_, i) => (
					<TableRow key={`app-partners-dialog-skeleton-${i}`}>
						<TableCell>
							<Skeleton width={150} />
						</TableCell>
						<TableCell>
							<Skeleton width={60} borderRadius={9999} />
						</TableCell>
						<TableCell>
							<Skeleton width={40} height={24} borderRadius={9999} />
						</TableCell>
					</TableRow>
				))}
			</TableBody>
		</AppPartnersDialogLayout>
	);
}
